var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ModalService } from '@ibe/services/ui';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { DomSanitizer } from '@angular/platform-browser';
import { INDRAIbeAdminConfigService } from "@ibe.services/ibeadmin-config.service";
var INDRAPaymentPaybyrdModalComponent = /** @class */ (function (_super) {
    __extends(INDRAPaymentPaybyrdModalComponent, _super);
    function INDRAPaymentPaybyrdModalComponent(cdr, modalService, sanitizer, ibeAdminConfigService) {
        var _this = _super.call(this, modalService) || this;
        _this.cdr = cdr;
        _this.modalService = modalService;
        _this.sanitizer = sanitizer;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.url = "";
        _this.showLoading = false;
        _this.errMsg = "";
        _this.resizeEventEnabled = false;
        return _this;
    }
    INDRAPaymentPaybyrdModalComponent.prototype.ngOnInit = function () {
        this.INDRA_loadPaybyrd();
    };
    INDRAPaymentPaybyrdModalComponent.prototype.INDRA_loadPaybyrd = function () {
        var configData = { compact: true };
        var configs = btoa(JSON.stringify(configData));
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue('externalURLs.paybyrdPaymentUrl');
        var resizeEvent = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.paybyrdResizeEventEnabled');
        if (resizeEvent == "true") {
            this.resizeEventEnabled = JSON.parse(resizeEvent);
        }
        if (this.data[0].status === '200' && this.data[0].errors.length != 1) {
            this.showLoading = true;
            var urlNavigate = urlIbeAdmin.replace('{CHECKOUT_ID}', "" + this.data[0].data.checkoutKey).replace('{ORDER_ID}', "" + this.data[0].data.orderId).replace('{CONFIGS}', "" + configs);
            // urlNavigate contains config, checkoutUrl don't.
            this.url = urlIbeAdmin ? urlNavigate : this.data[0].data.checkoutUrl;
            this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
        }
        else {
            this.errMsg = this.data[0].errors[0].desc;
        }
        if (this.resizeEventEnabled) {
            window.addEventListener('message', function (event) {
                // extracts data from the received message
                // const { type = null, payload = null } = event && event.data ? event.data || {} : {};
                var _a = event.data || {}, _b = _a.type, type = _b === void 0 ? null : _b, _c = _a.payload, payload = _c === void 0 ? null : _c;
                //validates if the message corresponds to the correct event
                if (type === 'PAYBYRD_HOSTED_FORM_WINDOW_RESIZE') {
                    var height = payload.height, width = payload.width;
                    // Selects iframe for the ID
                    var iframeWrapper = document.getElementById('iframe-element');
                    // Adjusts dinamically height of the iframe
                    // Width adjustment not necessary
                    if (iframeWrapper) {
                        // iframeWrapper.style.width = `${width}px`;
                        iframeWrapper.style.height = height + "px";
                    }
                }
            });
        }
    };
    INDRAPaymentPaybyrdModalComponent.prototype.INDRA_close = function () {
        this.closeModal();
    };
    INDRAPaymentPaybyrdModalComponent.prototype.onLoad = function () {
        this.showLoading = false;
    };
    INDRAPaymentPaybyrdModalComponent.prototype.ngOnDestroy = function () {
    };
    INDRAPaymentPaybyrdModalComponent.prototype.ngAfterContentChecked = function () {
        this.cdr.detectChanges();
    };
    return INDRAPaymentPaybyrdModalComponent;
}(AbstractModalContentComponent));
export { INDRAPaymentPaybyrdModalComponent };
